export default "__VITE_ASSET__8b4b2a14__"